import getConfig from '@ringcentral/rwc-utils/src/config';
import {
    getBrandIdFromUrlWithoutFallback,
    RING_CENTRAL_BRAND_ID,
    RC_BRAND_IDS,
} from './brand-info';
import { ProDomainMap } from './domain-map';
import { checkIsSameSite } from '@ringcentral/rwc-utils/src/url';

export { getBrandName } from '@low/web-client-info';

const DEFAULT_BRAND_DOMAIN = 'v.ringcentral.com';
const PASConf = getConfig('PAS');
export const isDynamicBrand = Boolean(getConfig('dynamic'));

export const getBrandId = (): string =>
    String(getBrandIdFromUrlWithoutFallback() || PASConf?.brandId);

export const getBrandDomain = (): string => {
    const brandId = getBrandId();
    return (
        Object.keys(ProDomainMap).find(domain => ProDomainMap[domain] === brandId) ??
        DEFAULT_BRAND_DOMAIN
    );
};

export const getIsRCBrand = (): boolean => getBrandId() === RING_CENTRAL_BRAND_ID;

export const getIsAnyRCBrand = (): boolean => RC_BRAND_IDS.includes(getBrandId());

export const isJustDynamicBranding = domain =>
    isDynamicBrand && !getIsRCBrand() && checkIsSameSite(domain, `https://${DEFAULT_BRAND_DOMAIN}`);
